import {
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DialogoConfirmacion } from "../../basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../basicsComponents/LoadingBackdrop/LoadingBackdrop";
import CustomDesplegable from "../../basicsComponents/CustomDesplegable/CustomDesplegable";
import CustomInput from "../../basicsComponents/CustomInput/CustomInput";
import { Row } from "../../basicsComponents/MaterialGridComponents";
import { useHistory } from "react-router";
import { Typography } from "@mui/joy";

const ModalPacienteForm = ({
  openModal,
  setOpenModal,
  mostrarNotificacion,
  paciente,
  setPaciente,
}) => {
  const [cargando, setCargando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [celular, setCelular] = useState("");
  const [nroDocumento, setNroDocumento] = useState("");
  const [tiposDoc, setTiposDoc] = useState([]);
  const [mutuales, setMutuales] = useState([]);
  const [mutualAfiliado, setMutualAfiliado] = useState("");
  const [tipoDoc, setTipoDoc] = useState(-1);
  const [mutual, setMutual] = useState(-1);
  const [errores, setErrores] = useState({
    nombre: false,
    apellido: false,
    correo: false,
    fechaNac: false,
    fechaSelect: false,
    celular: false,
    nroDocumento: false,
    mutualAfiliado: false,
    tipoDoc: false,
    mutual: false,
  });
  const [abrirModalCancelarRegistro, setAbrirModalCancelarRegistro] =
    useState(false);
  const [abrirDesplegableTiposDoc, setAbrirDesplegableTiposDoc] =
    useState(false);
  const [abrirDesplegableMutuales, setAbrirDesplegableMutuales] =
    useState(false);
  const history = useHistory();
  // agregar metodos modal confirmacion y cierre de ventana
  const [abrirDialogoReiniciarSesion, setAbrirDialogoReiniciarSesion] =
    useState(false);

  const traerTiposDocs = async () => {
    let tiposDocs = null;
    const url = localStorage.getItem("urlAxioPP");

    try {
      const response = await axios.get(`${url}Pacientes/DocumentoTipoTraer`);
      if (response.data.length !== 0) {
        tiposDocs = response.data;
      } else {
        tiposDocs = null;
      }

      tiposDocs = tiposDocs.map((tipoDoc) => {
        return {
          ...tipoDoc,
          text: tipoDoc.nombre,
        };
      });

      setTiposDoc(tiposDocs);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar los tipos de documentos",
        "rojo"
      );
    }
  };

  const traerMutuales = async () => {
    let mutuales = null;
    const url = localStorage.getItem("urlAxioPP");

    try {
      const response = await axios.get(`${url}Mutuales`);
      if (response.data.length !== 0) {
        mutuales = response.data;
      } else {
        mutuales = null;
      }

      mutuales = mutuales.map((mutual) => {
        return {
          ...mutual,
          text: mutual.nombre,
        };
      });

      setMutuales(mutuales);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar las mutuales registradas",
        "rojo"
      );
    }
  };

  const limpiarCampos = () => {
    setNombre("");
    setApellido("");
    setFechaNac("");
    setTipoDoc(-1);
    setNroDocumento("");
    setMutual(-1);
    setMutualAfiliado("");
    setCelular("");
    setCorreo("");
  };

  useEffect(() => {
    if (paciente?.codigo && mutuales.length === 0) {
      traerTiposDocs();
      traerMutuales();
    }
    if (paciente?.codigo && mutuales.length !== 0 && openModal) {
      setNombre(paciente.nombre);
      setApellido(paciente.apellido);
      setCorreo(paciente.email);

      // Convertir la fecha del backend (yyyy-mm-dd) a dd/mm/yyyy
      const fechaBackend = paciente.nacimiento.split("T")[0]; // Obtener la fecha sin la hora
      const [year, month, day] = fechaBackend.split("-"); // Separar año, mes y día
      const fechaFormateada = `${day}/${month}/${year}`; // Formatear como dd/mm/yyyy

      setFechaNac(fechaFormateada); // Mostrar la fecha formateada

      setCelular(paciente.celular);
      setNroDocumento(paciente.documentoNro);
      setMutualAfiliado(paciente.mutualAfiliado);
      setTipoDoc(paciente.documentoTipo);
      setMutual(paciente.mutual);
    }
    if (!openModal) {
      limpiarCampos();
    }
  }, [openModal, paciente, mutuales]);

  const handleChangeSelect = (value, select) => {
    switch (select) {
      case "Obra social":
        setMutual(value);
        break;
      case "Tipo Documento":
        setTipoDoc(value);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const getTextoDesplegableSeleccionado = (array, codigo) => {
    return array[array.findIndex((item) => item.codigo === codigo)].text;
  };

  const validarFormRegistroPaciente = () => {
    let pasa = true;
    let errors = {};
    if (nombre === "" || nombre === null || nombre === undefined) {
      pasa = false;
      errors.nombre = true;
    }
    if (apellido === "" || apellido === null || apellido === undefined) {
      pasa = false;
      errors.apellido = true;
    }
    if (fechaNac === "" || fechaNac === null || fechaNac === undefined) {
      pasa = false;
      errors.fechaNac = true;
    }
    if (celular === "" || celular === null || celular === undefined) {
      pasa = false;
      errors.celular = true;
    }
    if (
      nroDocumento === "" ||
      nroDocumento === null ||
      nroDocumento === undefined
    ) {
      pasa = false;
      errors.nroDocumento = true;
    }
    if (
      correo === "" ||
      correo === null ||
      correo === undefined ||
      !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(
        correo
      )
    ) {
      pasa = false;
      errors.correo = true;
    }
    if (tipoDoc === null || tipoDoc === undefined || tipoDoc === -1) {
      pasa = false;
      errors.tipoDoc = true;
    }
    setErrores(errors);
    return pasa;
  };

  const registrarPaciente = async () => {
    const token = sessionStorage.getItem("AppHCToken");
    const url = localStorage.getItem("urlAxioPP");

    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const response = await axios.post(
        `${url}pacientes`,
        {
          hc: nroDocumento,
          documentoNro: nroDocumento,
          documentoTipo: tipoDoc,
          documentoTipoNombre: getTextoDesplegableSeleccionado(
            tiposDoc,
            tipoDoc
          ),
          nombre: nombre,
          apellido: apellido,
          mutual: 1,
          mutualNombre: "Particular",
          celular: celular,
          email: correo,
          mutualAfiliado: "-",
          nacimiento: fechaNac,
          password: nroDocumento,
        },
        config
      );
      if (response) {
        if (response.status === 200) {
          mostrarNotificacion(
            true,
            "Usuario registrado correctamente",
            "verde"
          );
          limpiarCampos();
          setOpenModal(false);
        }
        if (response.status === 400) {
          mostrarNotificacion(
            true,
            "No se ha podido registrar el nuevo usuario debido a: " + response,
            "rojo"
          );
        }
      } else {
        mostrarNotificacion(true, "Falta rellenar algunos campos", "rojo");
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const obtenerPaciente = async () => {
    const url = localStorage.getItem("urlAxioPP");
    let sesion = JSON.parse(sessionStorage.getItem("ppUL"));
    try {
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      const response = await axios.get(
        `${url}Pacientes?documento=${nroDocumento}`,
        config
      );
      const data = response.data[0];
      sesion = {
        ...sesion,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
      // sessionStorage.setItem("ppUL", JSON.stringify(sesion));
      setPaciente(sesion);
      setOpenModal(false);
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los datos del paciente",
        "rojo"
      );
    }
  };

  const modificarPaciente = async () => {
    const url = localStorage.getItem("urlAxioPP");

    let config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    // Verificar el valor de fechaNac antes de enviarlo
    console.log("Fecha de nacimiento enviada (modificarPaciente):", fechaNac);
    const convertirFormatoFecha = (fecha) => {
      const [dia, mes, año] = fecha.split("/");
      return `${mes}/${dia}/${año}`;
    };

    const fechaConvertida = convertirFormatoFecha(fechaNac);
    try {
      const response = await axios.put(
        `${url}Pacientes/PutMe`,
        {
          codigo: paciente.codigo,
          hc: paciente.hc,
          documentoNro: nroDocumento,
          documentoTipo: tipoDoc,
          documentoTipoNombre: getTextoDesplegableSeleccionado(
            tiposDoc,
            tipoDoc
          ),
          nombre: nombre,
          apellido: apellido,
          mutual: mutual,
          mutualNombre: getTextoDesplegableSeleccionado(mutuales, mutual),
          celular: +celular,
          email: correo,
          mutualAfiliado: mutual !== 1 ? mutualAfiliado : "-",
          nacimiento: fechaConvertida,
          password: nroDocumento,
        },
        config
      );
      if (response) {
        if (response.status === 200) {
          mostrarNotificacion(
            true,
            "Usuario modificado correctamente",
            "verde"
          );
          await obtenerPaciente();
        }
        if (response.status === 400) {
          mostrarNotificacion(
            true,
            "No se ha podido modificar el usuario debido a: " + response,
            "rojo"
          );
        }
      } else {
        mostrarNotificacion(true, "Falta rellenar algunos campos", "rojo");
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const confirmarCancelarRegistro = () => {
    limpiarCampos();
    setOpenModal(false);
  };

  const togleAbrirCerrarCancelarRegistro = () => {
    if (paciente?.codigo) {
      confirmarCancelarRegistro(); // Cierra el modal y limpia los campos
    } else {
      setAbrirModalCancelarRegistro(true); // Abre el diálogo de confirmación
    }
  };

  // Función para manejar el clic en "Grabar y salir"
  const handleClickRegistrarPaciente = async () => {
    if (validarFormRegistroPaciente()) {
      if (paciente?.codigo) {
        await modificarPaciente();
      } else {
        await registrarPaciente();
      }
      setAbrirDialogoReiniciarSesion(true);
    }
  };

  // Función para manejar la confirmación de reiniciar sesión
  const handleClickConfirmar = () => {
    window.location.href = "/Login"; // Redirigir al login
  };

  useEffect(() => {}, [abrirDesplegableMutuales]);
  // agregar metodos modal confirmacion y cierre de ventana
  const [error, setError] = useState(false);

  const formatearFecha = (valor) => {
    // Eliminar caracteres no numéricos
    const limpio = valor.replace(/\D/g, "");

    let fechaFormateada = limpio;
    if (limpio.length >= 3 && limpio.length <= 4) {
      // Formato dd/mm
      fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(2, 4)}`;
    } else if (limpio.length >= 5 && limpio.length <= 8) {
      // Formato dd/mm/yyyy
      fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(
        2,
        4
      )}/${limpio.slice(4, 8)}`;
    }

    return fechaFormateada;
  };

  const handleFechaChange = (e) => {
    const valorFormateado = formatearFecha(e.target.value);
    setFechaNac(valorFormateado);

    // Validación de la fecha en formato dd/mm/yyyy
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    setError(valorFormateado.length === 10 && !regex.test(valorFormateado));
  };

  return (
    <IonModal
      isOpen={openModal}
      backdropDismiss={Boolean(paciente?.codigo)}
      onDidDismiss={() => setOpenModal(false)}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            {paciente?.codigo
              ? "Verifique sus datos"
              : "Registrarme como nuevo paciente"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" id="inbox-list">
        <Row>
          <IonCol sizeXs="12" style={{ textAlign: "start" }} container>
            <CustomInput
              label="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              error={errores.nombre}
              id="nombre"
              placeholder="Ingrese su nombre"
              errorHelperText="No se ingreso el nombre"
              disabled={paciente?.codigo}
            />
          </IonCol>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Apellido"
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
              error={errores.apellido}
              id="apellido"
              placeholder="Ingrese su apellido"
              errorHelperText="No se ingreso el apellido"
              disabled={paciente?.codigo}
            />
          </IonCol>
        </Row>

        <Row>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomDesplegable
              array={tiposDoc}
              value={tipoDoc}
              handleChange={handleChangeSelect}
              mostrarTodos={false}
              mostrarSearch={false}
              barraBusqueda={true}
              label="Tipo de documento"
              id="Tipo Documento"
              ocultarLabel={true}
              className={`${errores.tipoDoc && "ion-invalid"}`}
              errorText="No se selecciono un tipo de documento"
              isOpen={abrirDesplegableTiposDoc}
              setIsOpen={setAbrirDesplegableTiposDoc}
              error={errores.tipoDoc}
              placeholder="Seleccione un tipo de documento..."
              errorHelperText="No se selecciono un tipo de documento"
              disabled={paciente?.codigo}
            />
          </IonCol>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Nro de documento"
              value={nroDocumento}
              onChange={(e) => setNroDocumento(e.target.value)}
              error={errores.nroDocumento}
              id="nroDocumento"
              placeholder="Ingrese su nro de documento"
              errorHelperText="No se ingreso un nro de documento"
              disabled={paciente?.codigo}
            />
          </IonCol>
        </Row>

        <Row>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Fecha de nacimiento"
              value={fechaNac}
              onChange={handleFechaChange}
              error={errores.fechaNac}
              id="fechaNac"
              placeholder="dd/mm/yyyy"
              errorHelperText="No se ingresó una fecha de nacimiento válida"
              type="text"
              inputSlotProps={{
                min: dayjs().subtract(110, "year").format("YYYY-MM-DD"),
                max: dayjs().format("YYYY-MM-DD"),
              }}
              maxLength={10}
            />
          </IonCol>
        </Row>
        <Row>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Celular"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
              error={errores.celular}
              id="celular"
              placeholder="Ingrese su nro celular"
              errorHelperText="No se ingreso el nro celular"
              type="number"
              // disabled={paciente?.codigo}
            />
          </IonCol>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              error={errores.correo}
              id="correo"
              placeholder="Ingrese su correo"
              errorHelperText="No se ingreso un valido correo"
              type="email"
              // disabled={paciente?.codigo}
            />
          </IonCol>
        </Row>
        {paciente?.codigo && (
          <Row>
            <IonCol sizeXs="12" style={{ textAlign: "start" }}>
              <CustomDesplegable
                array={mutuales}
                value={mutual}
                handleChange={handleChangeSelect}
                mostrarTodos={false}
                mostrarSearch={true}
                barraBusqueda={true}
                label="Obra social"
                id="Obra social"
                ocultarLabel={true}
                className={`${errores.mutual && "ion-invalid"}`}
                isOpen={abrirDesplegableMutuales}
                setIsOpen={setAbrirDesplegableMutuales}
                error={errores.mutual}
                placeholder="Seleccione una obra social..."
                errorHelperText="No se selecciono una obra social"
                disabled={paciente?.codigo}
              />
            </IonCol>
            <IonCol sizeXs="12" style={{ textAlign: "start" }}>
              <CustomInput
                label="Numero de afiliado"
                value={mutualAfiliado}
                onChange={(e) => setMutualAfiliado(e.target.value)}
                error={errores.mutualAfiliado}
                id="mutualAfiliado"
                placeholder="Ingrese su nro de afiliado"
                errorHelperText="No se ingreso un nro de afiliado"
                disabled={paciente?.codigo}
              />
            </IonCol>
          </Row>
        )}
      </IonContent>
      <IonFooter>
        <Row container>
          <IonCol size="6" style={{ textAlign: "start" }}>
            <CustomInput
              value={paciente?.codigo ? "Salir" : "Cancelar registro"}
              onClick={togleAbrirCerrarCancelarRegistro}
              type="button"
              variant="solid"
              color="danger"
              // disabled={paciente?.codigo}
            />
          </IonCol>
          <IonCol size="6" style={{ textAlign: "start" }}>
            <CustomInput
              value={paciente?.codigo ? "Grabar y salir" : "Registrarme"}
              onClick={handleClickRegistrarPaciente}
              type="button"
              variant="solid"
              color="success"
            />
          </IonCol>
        </Row>
      </IonFooter>

      <DialogoConfirmacion
        titulo="Cancelar registro"
        contenido="¿Esta seguro de cancelar el registro? Se perderan los datos que haya cargado"
        abrirCerrarModal={abrirModalCancelarRegistro}
        handleclickBotonNo={togleAbrirCerrarCancelarRegistro}
        handleclickBotonSi={confirmarCancelarRegistro}
        colorBotonNo="amarillo"
        colorBotonSi="rojo"
        textoBotonNo="Cancelar"
        textoBotonSi="Estoy seguro"
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </IonModal>
  );
};

export default ModalPacienteForm;
